import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';

import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import FarmersList from './components/farmers-list';
import usePatch from '../../helpers/hooks/usePatch';
const Farmers = (props) => {
  const [activeFarmers, setActiveFarmers] = React.useState(false)
  const history = useHistory();
  const [farmers, , FarmersLoading, loadFarmers] = useGet(
    '/farmers?filter[include][0][relation]=language&filter[include][1][relation]=district&filter[order]=createdAt DESC',
    true
  );

  const handleEditAdvisor = useCallback(
    (obj) => {
      history.push(`/users/edit-farmer/${obj.id}`);
    },
    [history]
  );

  const [postFarmer, postedData, postingError, dataPosting] = usePatch();
  const handleStatusChange = (farmer, packages) => {
    postFarmer({ packages }, `/farmers/${farmer.id}`).then((e) =>
      loadFarmers()
    );
  };

  const toggleHandler = (packages) => {
    postFarmer({ packages }, `/farmers`).then((e) =>
      loadFarmers()
    );
  };


  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Farmers</h4>
            
            <Button
             outline
             color='primary'
             className=' waves-effect waves-light mr-1'
             onClick={()=>{toggleHandler(!activeFarmers); setActiveFarmers(!activeFarmers)}}
             >
               {activeFarmers ? "Deactivate All" : "Activate All"}
             </Button>
          </div>
          <Card>
            <CardBody>
              {FarmersLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <FarmersList
                  farmers={farmers}
                  editFarmer={handleEditAdvisor}
                  onStatusChange={handleStatusChange}
                ></FarmersList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Farmers;
